module.exports = __webpack_public_path__ + "img/banner-font.8dc9bc43.png";